import { render, staticRenderFns } from "./SpiMarker.vue?vue&type=template&id=5b254a17&"
import script from "./SpiMarker.vue?vue&type=script&lang=ts&"
export * from "./SpiMarker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports